/** @file Range of row indexes to render for a virtualized list (end exclusive, with overscan). */

/** Scroll position and geometry of a fixed-row-height list. */
export interface RangeArgs {
  scrollTop: number;
  viewportHeight: number;
  rowHeight: number;
  count: number;
  overscan: number;
}

/** First row and one-past-last row to render so that the viewport plus `overscan` rows on both sides is covered. */
export function visibleRange(a: RangeArgs): { start: number; end: number } {
  const start = Math.min(a.count, Math.max(0, Math.floor(a.scrollTop / a.rowHeight) - a.overscan));
  const end = Math.min(a.count, Math.ceil((a.scrollTop + a.viewportHeight) / a.rowHeight) + a.overscan);
  return { start, end: Math.max(start, end) };
}
